<template>
  <BigScreen @resize="handlerBigResize">
    <div class="vtm-shell">
      <!-- 左侧导航轨 -->
      <v-aside></v-aside>

      <!-- 右侧：头部 / 标签页 / 内容 -->
      <div class="vtm-shell__main">
        <v-header v-on:password="password"></v-header>
        <transition name="tags" mode="out-in">
          <v-tags v-show="tagsTop"></v-tags>
        </transition>
        <v-password :dialogPassword="dialogPassword" v-on:closePasswordDialog="passwordDialog"></v-password>
        <main class="vtm-shell__content">
          <div class="vtm-shell__panel">
            <!-- 只纵向滚动：横向滚动会让页面按内容撑宽（fit-content），宽表格就不出现自己的横向滚动条 -->
            <vue-scroll :ops="{ scrollPanel: { scrollingX: false } }">
              <transition name="move-main" mode="out-in">
                <keep-alive :include="tagList">
                  <router-view></router-view>
                </keep-alive>
              </transition>
            </vue-scroll>
          </div>
        </main>
      </div>

      <support-hub></support-hub>
      <beta-welcome></beta-welcome>
    </div>
  </BigScreen>
</template>

<script>
  import vPassword from "@/components/Password";
  import vTags from "@/components/Tags";
  import vAside from "@/components/sidebar/Aside";
  import vHeader from "@/components/Header";
  import BigScreen from "@/components/BigScreen.vue";
  import SupportHub from "_c/support/SupportHub";
  import BetaWelcome from "@/components/BetaWelcome";
  import Intercom from "@intercom/messenger-js-sdk";
  export default {
    name: "Index",
    data() {
      return {
        dialogPassword: false,
        tag: true,
        windowHeight: "" //实时屏幕高度
      };
    },
    components: {
      vPassword,
      vTags,
      vAside,
      vHeader,
      BigScreen,
      SupportHub,
      BetaWelcome
    },
    mounted() {
      const that = this;
      window.onresize = () => {
        if (document.body.clientWidth <= 1200) {
          that.$store.dispatch("collapse", true);
        } else {
          that.$store.dispatch("collapse", false);
        }
      };

      // Fetch machine numbers and initialize Intercom with custom attributes
      this.initializeIntercomWithMachines();
    },
    methods: {
      // Intercom call
      // showIntercom(){
      // Intercom('show')
      // },

      // Initialize Intercom with machine numbers
      async initializeIntercomWithMachines() {
        try {
          // Fetch all user machines
          const response = await this.$api.request(
            this.$url.UserMachine.userList,
            this.$method.get,
            {}
          );

          let machineNumbers = [];

          // Handle different response structures
          let machinesArray = [];
          if (response.code === 0 && response.data) {
            // Check if response.data is an array
            if (Array.isArray(response.data)) {
              machinesArray = response.data;
            } 
            // Check if response.data has a records property (paginated response)
            else if (response.data.records && Array.isArray(response.data.records)) {
              machinesArray = response.data.records;
            }
            // Check if response.data has a list property
            else if (response.data.list && Array.isArray(response.data.list)) {
              machinesArray = response.data.list;
            }
            // If response.data is an object with array-like structure
            else if (response.data.data && Array.isArray(response.data.data)) {
              machinesArray = response.data.data;
            }

            if (machinesArray.length > 0) {
              // Extract all equipment numbers from the response
              machineNumbers = machinesArray
                .map(machine => {
                  // Try different possible property names
                  return machine.equipmentNo || machine.equipment_id || machine.machineNo || machine.id || null;
                })
                .filter(Boolean); // Filter out any null/undefined values
            } else {
              console.warn("No machines found in response data structure");
            }
          } else {
            console.warn("API response failed or invalid. Code:", response.code);
          }

          // Send all machines - use comma without space to save characters
          const machineIdsToSend = machineNumbers.length > 0 ? machineNumbers.join(",") : "";

          // Initialize Intercom with custom attributes
          // Note: Intercom normalizes custom attribute keys
          // Try multiple key formats to match Intercom's expected format
          const intercomSettings = {
            app_id: "kx28g8jk",
            user_id: this.$cookies.get("uid"),
            email: this.$cookies.get("userName"),
            name: this.$cookies.get("nickName"),
            // Custom user attributes - Company Name and Machine Numbers
            company_name: "VapeTM",
            // Try the most common format (lowercase with spaces)
            "vapetm machine ids": machineIdsToSend,
            // No floating bubble: chat opens from the Help & Support panel
            hide_default_launcher: true
          };

          // Initialize Intercom
          Intercom(intercomSettings);

          // Wait a moment for Intercom to load, then boot it explicitly
          setTimeout(() => {
            if (window.Intercom) {
              window.Intercom('boot', intercomSettings);

              // Update Intercom with attributes again to ensure they're set
              setTimeout(() => {
                const updateData = {
                  company_name: "VapeTM",
                  "vapetm machine ids": machineIdsToSend
                };

                window.Intercom('update', updateData);
              }, 1000);
            }
          }, 500);

        } catch (error) {
          console.error("Error fetching machines for Intercom:", error);
          
          // Fallback: Initialize Intercom without machine numbers
          const fallbackSettings = {
            app_id: "kx28g8jk",
            user_id: this.$cookies.get("uid"),
            email: this.$cookies.get("userName"),
            name: this.$cookies.get("nickName"),
            company_name: "VapeTM",
            "vapetm machine ids": "",
            hide_default_launcher: true
          };

          Intercom(fallbackSettings);

          setTimeout(() => {
            if (window.Intercom) {
              window.Intercom('boot', fallbackSettings);
            }
          }, 500);
        }
      },

      handlerBigResize(scale) {
        this.windowHeight = 100 / scale; // 高
      },
      passwordDialog(password) {
        this.dialogPassword = password;
      },
      password(password) {
        this.dialogPassword = password;
      }
    },
    computed: {
      collapse() {
        return this.$store.state.collapse;
      },
      tagList() {
        return this.$store.state.tagList;
      },
      tagsTop() {
        return this.$store.state.tagsTop;
      }
    },
    created() {
      if (!this.$store.state.menuList || this.$store.state.menuList.length <= 0) {
        this.$router.push("/login");
      }
      if (this.$route.path === "" || this.$route.path === "/") {
        this.$router.push("/main");
      }
      if (document.body.clientWidth <= 1200) {
        this.$store.dispatch("collapse", true);
      }
    }
  };
</script>

<style lang="scss">
  .vtm-shell {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: var(--vtm-bg);
  }

  .vtm-shell__main {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    height: 100%;
  }

  .vtm-shell__content {
    flex: 1;
    min-height: 0;
    padding: 14px;
    display: flex;
  }

  .vtm-shell__panel {
    flex: 1;
    min-width: 0;
    background: var(--vtm-surface);
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-lg);
    overflow: hidden;
  }

  .move-main-enter-active,
  .move-main-leave-active {
    transition: all 0.3s;
  }

  .move-main-enter {
    opacity: 0;
    transform: translateX(-18px);
  }

  .move-main-leave-to {
    opacity: 0;
    transform: translateX(18px);
  }

  .tags-enter-active,
  .tags-leave-active {
    transition: all 0.3s;
  }

  .tags-enter,
  .tags-leave-to {
    opacity: 0;
  }

  .__view {
    width: 100% !important;
  }
</style>
